import {getUser} from "./util-auth";
import {COMPANY_FREIGHT_HOUSE, COMPANY_NATIONWIDE_BROKERAGE, COMPANY_AAM, COMPANY_DB} from "../../util/util-constants";

// Note: use src/common/util/util-exceptions.jsx

const SETTINGS_EXCEPTIONS = {
    OfficeIdDefaultValue: {
        [COMPANY_AAM]: "",
        [COMPANY_DB]: ""
    },
    TriumphPrimaryName: {
        [COMPANY_AAM]: " (AAM Network)"
    },
    TriumphSecondaryName: {
        [COMPANY_AAM]: " (AlphaAndMike)"
    },
    TriumphTertiaryName: {
        [COMPANY_AAM]: ""
    },
    ExternalCarrierNotesRows: {
        [COMPANY_NATIONWIDE_BROKERAGE]: 14
    },
    isCarrierNotesExpandedByDefault: {
        [COMPANY_NATIONWIDE_BROKERAGE]: true
    },
    isSendEmailRateConfirmationDisabled: {
        [COMPANY_FREIGHT_HOUSE]: true
    }
}

export default function LoadCompanySettings(settingKey, defaultValue) {
    const companyID = getUser('CompanyID');
    return SETTINGS_EXCEPTIONS[settingKey]?.[companyID] ?? defaultValue;
}
